import React from 'react';
import { CRASH_CODE, CRASH_COPY } from '../utils/friendlyError';

/**
 * CastingErrorBoundary — wraps the casting page. If rendering crashes it shows a
 * fixed message and a Refresh button. It never renders the error, its message, a
 * stack or the developer code, and it logs nothing but { code, status }.
 *
 * (components/ErrorBoundary.jsx is different: it only silences Google Translate
 * DOM errors and is left untouched.)
 */
class CastingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    console.warn('[casting] page failed to render', { code: CRASH_CODE, status: undefined });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Inline styles on purpose: the page's own styles are injected by the page
    // component, which is the thing that just crashed.
    return (
      <div
        role="alert"
        style={{
          minHeight: '50vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          padding: 24,
          textAlign: 'center',
        }}
      >
        <p style={{ margin: 0, fontSize: 18 }}>{CRASH_COPY}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 22px',
            fontSize: 15,
            fontWeight: 600,
            borderRadius: 8,
            border: '1px solid currentColor',
            background: 'transparent',
            color: 'inherit',
            cursor: 'pointer',
          }}
        >
          Refresh
        </button>
      </div>
    );
  }
}

export default CastingErrorBoundary;
